import { InjectionToken } from '@angular/core';

export const MENU_DATA_TOKEN = new InjectionToken<any>('MENU_DATA_TOKEN');
